import React from "react";
import PropTypes from "prop-types";
import { Typography, ButtonBase, Tooltip, CircularProgress } from "@mui/material";
import ArrowUpwardIcon from "@mui/icons-material/ArrowUpward";
import ArrowDownwardIcon from "@mui/icons-material/ArrowDownward";
import "./UnderPaymentListSidePanel.scss";

export default function UnderPaymentListSidePanel({
  columnLabel,
  groups,
  selectedKey,
  onSelect,
  formatCurrency,
  sortDirection,
  onToggleSort,
  isLoading
}) {
  const isAscending = sortDirection === "asc";
  const sortTooltip = isAscending ? "Sort descending" : "Sort ascending";

  return (
    <div className="underpayment-list-side-panel">
      <div className="underpayment-list-side-panel-header">
        <Tooltip title={sortTooltip}>
          <ButtonBase
            className="underpayment-list-side-panel-sort-btn"
            onClick={onToggleSort}
            aria-label={sortTooltip}
          >
            <span className="underpayment-list-side-panel-header-label">{columnLabel}</span>
            {isLoading ? (
              <CircularProgress
                size={12}
                thickness={6}
                className="underpayment-list-side-panel-sort-spinner"
              />
            ) : isAscending ? (
              <ArrowUpwardIcon className="underpayment-list-side-panel-sort-icon" fontSize="inherit" />
            ) : (
              <ArrowDownwardIcon className="underpayment-list-side-panel-sort-icon" fontSize="inherit" />
            )}
          </ButtonBase>
        </Tooltip>
        <span className="underpayment-list-side-panel-header-count">Records</span>
      </div>

      <div className="underpayment-list-side-panel-items">
        {groups.length ? (
          groups.map(group => (
            <ButtonBase
              key={group.key}
              className={`underpayment-list-side-panel-item ${
                group.key === selectedKey ? "underpayment-list-side-panel-item--active" : ""
              }`}
              onClick={() => onSelect(group.key)}
            >
              <div className="underpayment-list-side-panel-item-label">
                <Typography className="underpayment-list-side-panel-item-title">{group.label}</Typography>
                <Typography className="underpayment-list-side-panel-item-amount">
                  {formatCurrency(group.amount)}
                </Typography>
              </div>
              <span className="underpayment-list-side-panel-item-count">{group.count}</span>
            </ButtonBase>
          ))
        ) : (
          <div className="underpayment-list-side-panel-empty">
            {isLoading ? (
              <CircularProgress size={20} className="underpayment-list-side-panel-empty-spinner" />
            ) : (
              <Typography className="underpayment-list-side-panel-empty-text">No Data</Typography>
            )}
          </div>
        )}
      </div>
    </div>
  );
}

UnderPaymentListSidePanel.propTypes = {
  columnLabel: PropTypes.string.isRequired,
  groups: PropTypes.arrayOf(
    PropTypes.shape({
      key: PropTypes.string,
      label: PropTypes.string,
      count: PropTypes.number,
      amount: PropTypes.number
    })
  ).isRequired,
  selectedKey: PropTypes.string,
  onSelect: PropTypes.func.isRequired,
  formatCurrency: PropTypes.func.isRequired,
  sortDirection: PropTypes.oneOf(["asc", "desc"]),
  onToggleSort: PropTypes.func.isRequired,
  isLoading: PropTypes.bool
};

UnderPaymentListSidePanel.defaultProps = {
  selectedKey: null,
  sortDirection: "asc",
  isLoading: false
};